import styled from 'styled-components/macro';
import AboutUsFeatures from './features';
import media from "../../constants/MediaQuery";

const WhatWeDo = () => {
    return (
      <WWDStyling>
        <div className="WhatWeDo__WWDStyling__wwd-container container">
          <div className="WhatWeDo__WWDStyling__wwd-container__wwd-emage">
            <div className="WhatWeDo__WWDStyling__wwd-container__wwd-emage--dot-emage" style={{ backgroundImage: "url('/assets/images/dots.svg')" }} />
            <img className="POS-image" src="./assets/images/POS.png" alt="POS" />
          </div>
          <AboutUsFeatures />
        </div>
      </WWDStyling>
    );
};
const WWDStyling = styled.section`
  padding: 100px 0;
  display: flex;
.POS-image{
  width: 100%;
  max-width: 400px;
  position: relative;
  @media screen and (max-width: 600px){
    display: none;
  }
  ${media.tabletMin` display: block;`}
}
  .WhatWeDo__WWDStyling{
    &__wwd-container{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      ${media.smallDesktopMin`flex-direction: row;`}
      &__wwd-emage{
        position: relative;
        width: 100%;
        max-width: 430px;
        height: 100%;
        display: flex;
        justify-content: center;
        &--dot-emage{
          max-width: 600px;
          width: 20%;
          height: 100%;
          max-height: 466px;
          position: absolute;
          left: 0;
          bottom: 55px;
        }
      }

    }
  }
  
`;
export default WhatWeDo;
